import { render, staticRenderFns } from "./TypeCrud.vue?vue&type=template&id=0e8d1304&"
import script from "./TypeCrud.vue?vue&type=script&lang=js&"
export * from "./TypeCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports